import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalContentText,
    ModalTitle,
} from '@deere/fuel-react';
import { PropTypes } from 'prop-types';
import { usePrompt } from '../../hooks/usePrompt';
import { usePromptNavigation } from '../../hooks/usePromptNavigation';

export const PromptValidState = (props) => {
    usePrompt(props.isFormChanged);
    const [showPrompt, leavePage, stayOnPage, pausePage] = usePromptNavigation(
        props.isFormChanged
    );

    const saveChanges = () => {
        pausePage();
        props.saveChanges();
        if (props.areAllFieldsValid()) {
            leavePage();
        }
    };

    return (
        <Modal
            open={showPrompt}
            onClose={stayOnPage}
            aria-labelledby="alert-Modal-title"
            aria-describedby="alert-Modal-description"
        >
            <ModalTitle id="alert-Modal-title">
                Do You Want to Save Changes?
            </ModalTitle>
            <ModalContent>
                <ModalContentText id="alert-Modal-description">
                    {props.message !== null && <span>{props.message}</span>}
                    {props.message == null && (
                        <span>
                            If you leave the page without clicking Save, your
                            changes will be deleted.
                        </span>
                    )}
                </ModalContentText>
            </ModalContent>
            <ModalActions>
                <Button onClick={leavePage} variant="secondary">
                    Do Not Save Changes
                </Button>
                <Button onClick={saveChanges} variant="primary">
                    Save Changes
                </Button>
            </ModalActions>
        </Modal>
    );
};
PromptValidState.propTypes = {
    isFormChanged: PropTypes.bool.isRequired,
    saveChanges: PropTypes.func.isRequired,
    areAllFieldsValid: PropTypes.func.isRequired,
    message: PropTypes.string,
};
